var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lease-product-page" },
    [
      _c("el-card", { staticClass: "lease-config-card" }, [
        _c(
          "div",
          { staticStyle: { height: "80px", background: "#ffffff" } },
          [
            _c(
              "div",
              { staticStyle: { color: "#666666", "margin-bottom": "10px" } },
              [
                _c("p", { staticStyle: { "margin-bottom": "10px" } }, [
                  _vm._v(
                    "最大租赁天数：" +
                      _vm._s(_vm.leaseConfig.maxLeaseDuration || "未配置") +
                      "天"
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "hasPermi",
                    rawName: "v-hasPermi",
                    value: ["admin:product:update"],
                    expression: "['admin:product:update']",
                  },
                ],
                attrs: { type: "primary", size: "mini" },
                on: { click: _vm.openLeaseConfigDialog },
              },
              [_vm._v("租赁配置\n        ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "租赁配置",
            visible: _vm.leaseConfigDialogVisible,
            width: "900px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.leaseConfigDialogVisible = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _vm.leaseConfigDialogVisible
            ? _c("lease-config", {
                attrs: { "dialog-edit-data": _vm.currentLeaseData },
                on: {
                  refresh: _vm.fetchLeaseConfig,
                  "close-dialog": function ($event) {
                    _vm.leaseConfigDialogVisible = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("store-index", {
        staticClass: "lease-product-list",
        attrs: {
          "biz-type": 3,
          "create-or-edit-url": "/leaseProduct/list/creatProduct",
          "detail-url": "/leaseProduct/list/productDetail",
          "inventory-adjust-url": "/leaseProduct/list/inventoryAdjust",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }